import { faSpinnerThird } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon, type FontAwesomeIconProps } from "@fortawesome/react-fontawesome";
import type { CSSProperties } from "react";
import { cn } from "../../..";

export function LoadIcon(props: Omit<FontAwesomeIconProps, "icon">) {
	const { className, ...remainingProps } = props;

	return (
		<FontAwesomeIcon
			className={cn(className, "animate-spin")}
			icon={faSpinnerThird}
			fixedWidth
			style={
				{
					"--fa-primary-color": "rgb(var(--color-primary-medium))",
					"--fa-secondary-color": "rgb(var(--color-shades-medium))",
				} as CSSProperties
			}
			{...remainingProps}
		/>
	);
}
